import { render, staticRenderFns } from "./schoolEventDetail.vue?vue&type=template&id=68d41cf4"
import script from "./schoolEventDetail.vue?vue&type=script&lang=js"
export * from "./schoolEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports